"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var RadioPart_1;
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioPart = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const _part_includes_1 = require("../_part_includes");
//@ts-ignore                
let rwsTemplate = T.html `<div class="form-group${x => x.inline ? ' inline' : ''}${x => x.grid ? ' grid' : ''}">
    ${(0, fast_element_1.when)(x => x.label, T.html `<label class="form-label">${x => x.label.t()}</label>`)}
    <slot name="info"></slot>
    <div class="radio-group" ${(0, fast_element_1.ref)('radioGroup')}>
        ${T.repeat(x => x.options || [], T.html `
            <div class="form-check ${x => x.description ? 'has-description' : ''} ${(x, c) => c.parent.isSelected(x.value) ? 'is-selected' : ''}" @click="${(x, c) => c.parent.handleContainerClick(c.event, x.value)}">
                <input 
                    type="radio"
                    name="${(x, c) => c.parent.name}"
                    class="form-check-input"
                    :value="${x => x.value}"
                    @change="${(x, c) => c.parent.handleChange(c.event)}"
                    :checked="${(x, c) => c.parent.isSelected(x.value)}"
                    ?required="${(x, c) => c.parent.isRequired}"
                    style="--radio_size: ${(x, c) => c.parent.size ? c.parent.size + 'px' : 'inherit'}"
                />
                <div class="form-check-text">
                    <label class="form-check-label">
                        ${x => x.label.t()}
                    </label>
                    ${(0, fast_element_1.when)(x => x.description, T.html `<small class="form-check-description">${x => x.description.t()}</small>`)}
                </div>
            </div>
        `)}
    </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host-context(.force-placeholder) input::placeholder,
select::placeholder,
textarea::placeholder {
  opacity: 1 !important;
}

.form-group.is-invalid label {
  color: var(--error_color) !important;
}
.form-group.is-invalid .form-control {
  border-color: var(--error_color) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
  color: var(--error_color) !important;
}

:host(.no-margin) .form-group {
  margin: 0 !important;
}

:host(.mini) .form-control {
  padding: 0.2rem 0.4rem;
  line-height: 0.8;
  font-size: 0.6rem;
}

:host(.rounded) .form-control {
  border-radius: 0.375rem;
}

.form-group > .form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.92rem;
  font-weight: 700;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-check {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  user-select: none;
}
.form-check:hover {
  background: var(--bg, #f4f5f7);
}
.form-check.is-selected {
  background: var(--brand-soft, #d7f2ee);
  border-color: rgba(23, 180, 166, 0.35);
}
.form-check.has-description {
  align-items: flex-start;
}
.form-check.has-description .form-check-input {
  margin-top: 4px;
}
.form-check .form-check-text {
  display: flex;
  flex-direction: column;
}
.form-check .form-check-description {
  margin-top: 2px;
  font-size: 0.75rem;
  line-height: 1.3;
  color: var(--color-text-secondary, #8f8f8f);
}
.form-check .form-check-input {
  position: static;
}

input[type=radio] {
  width: var(--radio_size, 16px);
  height: var(--radio_size, 16px);
  margin: 0;
}

:host-context(.static) input, :host-context(.static) label {
  position: static !important;
}

.no-label {
  margin-left: 0;
}

:host(.horizontal) .radio-group {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
}

:host(.inline) .radio-group {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
}

.form-group.grid .radio-group {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 2px 12px;
}

.form-group.inline .radio-group {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
}`;
const shadowOptions = { "mode": "open" };
let RadioPart = RadioPart_1 = class RadioPart extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.ignored = 'false';
        this.dontEmit = false;
        this.hoverevent = false;
        this.inline = false;
        this.grid = false;
        this.handleChange = (event) => {
            const target = event.target;
            this.value = target.value;
            if (this.onChange) {
                this.onChange(event);
            }
            _part_includes_1.handlePartChange.call(this, event);
            // Also dispatch standard "change" event for broader compatibility
            this.$emit('change', {
                value: this.value,
                name: target.name || this.name,
                element: target,
                formPartType: RadioPart_1.PART_TYPE
            });
        };
        this.handleContainerClick = (event, value) => {
            if (!this.radioGroup) {
                return;
            }
            const inputs = this.radioGroup.querySelectorAll('input[type="radio"]');
            const input = Array.from(inputs).find(i => i.value === String(value));
            if (!input) {
                return;
            }
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        };
        this.handleOptionHover = (event) => {
            const target = event.target;
            const formCheck = target.closest('.form-check');
            if (!formCheck || formCheck.contains(event.relatedTarget)) {
                return;
            }
            const input = formCheck.querySelector('input[type="radio"]');
            if (!input) {
                return;
            }
            const option = (this.options || []).find((opt) => String(opt.value) === String(input.value));
            if (!option) {
                return;
            }
            this.$emit('form-part:option:hover', {
                info: option.info,
                label: option.label,
                value: option.value,
                name: this.name,
                formPartType: RadioPart_1.PART_TYPE
            });
        };
        this.handleOptionUnhover = (event) => {
            const target = event.target;
            const formCheck = target.closest('.form-check');
            if (!formCheck || formCheck.contains(event.relatedTarget)) {
                return;
            }
            const input = formCheck.querySelector('input[type="radio"]');
            if (!input) {
                return;
            }
            const option = (this.options || []).find((opt) => String(opt.value) === String(input.value));
            if (!option) {
                return;
            }
            this.$emit('form-part:option:unhover', {
                info: option.info,
                label: option.label,
                value: option.value,
                name: this.name,
                formPartType: RadioPart_1.PART_TYPE
            });
        };
    }
    valueChanged(oldValue, newValue) {
        const strNewValue = String(newValue !== null && newValue !== void 0 ? newValue : '');
        if (this.radioGroup) {
            for (const input of this.radioGroup.querySelectorAll('input[type="radio"]')) {
                input.checked = input.value === strNewValue;
            }
        }
        if (this.options && this.options.length) {
            this.options = [...this.options];
        }
    }
    requiredChanged(oldValue, newValue) {
        this.required = newValue;
        this.isRequired = this.required === 'true';
    }
    connectedCallback() {
        var _a, _b;
        super.connectedCallback();
        if (this.hoverevent) {
            (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.addEventListener('mouseover', this.handleOptionHover);
            (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.addEventListener('mouseout', this.handleOptionUnhover);
        }
    }
    getElement() {
        // For radio groups, we need to find the checked input
        const checkedInput = this.$('input:checked');
        if (checkedInput) {
            return checkedInput;
        }
        // If no radio is checked, return the first radio input for validation purposes
        return this.$('input[type="radio"]');
    }
    reset() {
        const radioInputs = this.querySelectorAll('input[type="radio"]');
        radioInputs.forEach(input => {
            input.checked = false;
        });
        this.value = undefined;
    }
    // Helper method to check if a radio option is selected
    isSelected(optionValue) {
        var _a;
        return String((_a = this.value) !== null && _a !== void 0 ? _a : '') === String(optionValue);
    }
};
exports.RadioPart = RadioPart;
RadioPart.PART_TYPE = 'radio';
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], RadioPart.prototype, "label", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], RadioPart.prototype, "name", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], RadioPart.prototype, "value", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof Array !== "undefined" && Array) === "function" ? _a : Object)
], RadioPart.prototype, "options", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], RadioPart.prototype, "required", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Number)
], RadioPart.prototype, "size", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], RadioPart.prototype, "ignored", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], RadioPart.prototype, "dontEmit", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], RadioPart.prototype, "hoverevent", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], RadioPart.prototype, "inline", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], RadioPart.prototype, "grid", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], RadioPart.prototype, "isRequired", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], RadioPart.prototype, "onChange", void 0);
exports.RadioPart = RadioPart = RadioPart_1 = __decorate([
    (0, client_1.RWSView)('part-radio', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], RadioPart);
RadioPart.defineComponent();
